import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import ar from './locales/ar.json';
import en from './locales/en.json';

export const SUPPORTED_LANGUAGES = ['ar', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const RTL_LANGUAGES = new Set<string>(['ar']);

export function directionFor(lng: string): 'rtl' | 'ltr' {
  return RTL_LANGUAGES.has(lng.split('-')[0] ?? lng) ? 'rtl' : 'ltr';
}

function applyDocumentLanguage(lng: string): void {
  const root = document.documentElement;
  root.lang = lng;
  root.dir = directionFor(lng);
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    supportedLngs: [...SUPPORTED_LANGUAGES],
    fallbackLng: 'en',
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'pa.lang',
    },
  });

i18n.on('languageChanged', applyDocumentLanguage);
if (i18n.resolvedLanguage) applyDocumentLanguage(i18n.resolvedLanguage);

export default i18n;
